import { MutableRefObject } from 'react'
import {
  CHAMPIONS_SET_SELECTED_ROW_IDS,
  ROW_SELECT_ACTIONS,
} from 'champion/hooks/championsServerSideSelectionConstants'

export type ChampionsServerSideSelectionPluginApi = {
  onSelectedRowIdsChange: (ids: Record<string, boolean>) => void
  syncVolunteersFromSelection: (ids: Record<string, boolean>) => void
}

export const useChampionsServerSideSelectionPlugin = (
  apiRef: MutableRefObject<ChampionsServerSideSelectionPluginApi>,
) => {
  const plugin = (hooks: any) => {
    hooks.stateReducers.push((state: any, action: any) => {
      if (action.type === CHAMPIONS_SET_SELECTED_ROW_IDS) {
        return { ...state, selectedRowIds: action.selectedRowIds || {} }
      }

      if ((ROW_SELECT_ACTIONS as readonly string[]).includes(action.type)) {
        const nextIds = { ...(state.selectedRowIds || {}) }
        const api = apiRef.current
        api.onSelectedRowIdsChange(nextIds)
        api.syncVolunteersFromSelection(nextIds)
      }

      return state
    })
  }

  return plugin
}
